<template>
  <div class="landing-page-container">
    <div class="loading-page" v-if="!loaded">
      <div class="col-3">
        <div class="spin-neoron-chat"></div>
      </div>
    </div>
    <div v-show="startConversation">
      <before-chat-call-to-action
        :links="links"
        :botStyleConfig="botStyleConfig"
        :settings_before_chat="settingBeforeChat"
        :handleStartConversation="handleStartConversation"
      />
    </div>
    <transition name="fade-splash">
      <div
        :class="
          [
            'neoron-landing-chat landing-chat',
            widthScreen > 800 ? botStyleConfig.modelLayout : 'normal',
          ].join(' ')
        "
        :style="mobileHeight"
        v-if="!startConversation && loaded && showChat"
      >
        <div
          class="col template"
          :style="botStyleConfig"
          v-if="
            botStyleConfig.pageMode !== 'chat_only' &&
            (widthScreen > 800 ? true : false) &&
            channel != 'widget'
          "
        >
          <div class="container">
            <div class="row box-logo">
              <div class="col" v-if="logoActived">
                <img class="image-logo" :src="logo" :alt="botLayout.title" />
              </div>
            </div>
            <div class="row box-title">
              <p class="title">
                {{ title }}
              </p>
            </div>
            <div class="row box-subtitle">
              <p class="subtitle">
                {{ subtitle }}
              </p>
            </div>
            <div class="row links">
              <div class="col" v-for="(link, index) in links" :key="index">
                <a
                  :href="link.url"
                  :style="{ color: botStyleConfig.color }"
                  target="_blak"
                  rel="noopener noreferrer"
                >
                  <font-awesome-icon
                    :icon="['fab', `${link.name}`]"
                    v-if="link.name !== 'link'"
                  />
                  <font-awesome-icon :icon="['fas', `${link.name}`]" v-else />
                </a>
              </div>
            </div>
          </div>
        </div>
        <a-modal
          :visible="panel"
          :footer="null"
          :closable="false"
          wrapClassName="neoron-landing-chat landing-chat modal-marketing"
          transitionName="none"
          maskTransitionName="none"
        >
          <div class="col template" :style="botStyleConfig">
            <div
              class="close btn-close"
              @click="panelStatus(false)"
              style="cursor: pointer"
            >
              <p>x</p>
            </div>
            <div class="container">
              <div class="box-logo">
                <div class="col" v-if="logoActived">
                  <img class="image-logo" :src="logo" :alt="botLayout.title" />
                </div>
              </div>
              <div class="row box-title">
                <p class="title">
                  {{ title }}
                </p>
              </div>
              <div class="row box-subtitle">
                <p class="subtitle">
                  {{ subtitle }}
                </p>
              </div>
              <div class="row links">
                <div class="col" v-for="(link, index) in links" :key="index">
                  <a
                    :href="link.url"
                    :style="{ color: botStyleConfig.color }"
                    target="_blak"
                    rel="noopener noreferrer"
                  >
                    <font-awesome-icon
                      :icon="['fab', `${link.name}`]"
                      v-if="link.name !== 'link'"
                    />
                    <font-awesome-icon :icon="['fas', `${link.name}`]" v-else />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </a-modal>
        <div class="col chat">
          <div :class="loading">
            <div class="col-3">
              <div class="spin-neoron-chat"></div>
            </div>
          </div>
          <div
            class="container box-chat"
            :class="{ widget: channel === 'widget' }"
          >
            <div class="row header-chat">
              <div class="infoBot">
                <img id="bot-avatar" class="bot-avatar" :src="imgBot" />
                <p class="nameBot">{{ nameBot }}</p>
              </div>
              <div class="options">
                <a @click="timeRefresh">
                  <div :class="['img-refresh', active].join(' ')">&#8635;</div>
                </a>
              </div>
            </div>
            <chat
              class="chat-landing-page-neoron"
              :class="{ widget: channel === 'widget' }"
              :channel="channel"
              :bot_id="bot_id"
              :channel_config="botStyleConfig.chatbot"
              :initial_data="{ variables: this.variables }"
              :simulator_mode="simulator_mode"
              :enabled_chat="enabled_chat"
              :white_label="whiteLabel"
            />
          </div>
        </div>
        <div style="display: none">{{ titleHeader }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Chat from "@/modules/Chat/components/Chat.vue";
import "ant-design-vue/dist/antd.css";
import { Input, Modal } from "ant-design-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faYoutube,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faFacebookF,
  faGithub,
  faTwitter,
  faTiktok,
  faSpotify,
  faTelegram,
} from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import BeforeChatCallToAction from "../components/BeforeChatCallToAction.vue";
import { DEFAULT_BOT_AVATAR_URL } from "@/constants";

library.add(
  faYoutube,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faLink,
  faGithub,
  faFacebookF,
  faTwitter,
  faTiktok,
  faSpotify,
  faTelegram
);

export default {
  /*eslint-disable */
  components: {
    Chat,
    FontAwesomeIcon,
    BeforeChatCallToAction,
    AModal: Modal,
    AInput: Input,
  },
  props: {
    variables: {
      type: Object,
      default: null,
    },
    custom_link: {
      type: String,
      default: null,
    },
    bot_id_params: {
      type: String,
      default: null,
    },
    channel: {
      type: String,
      default: "landing",
    },
    simulator_mode: {
      type: Boolean,
      default: false,
    },
    token: {
      type: String,
    },
    enabled_chat: {
      type: Boolean,
      required: false,
      default: true,
    },

    mode_layout_props: {
      type: String,
      default: "desktop",
    },
  },

  data() {
    return {
      showChat: true,
      botStyleConfig: {
        backgroundImage: "",
        backgroundColor: "white",
        background: "white",
        color: "black",
        chatbot: {
          background_outgoing: "#f1f1f1",
          background_received: "#4d4b4b",
        },
        modelLayout: "right",
      },
      botCustomSettings: {},
      links: [{ name: "", url: "" }],
      title: "",
      subtitle: "",
      logo: "",
      active: "desactive",
      loading: "loading",
      loaded: false,
      logoActived: true,
      widthScreen: 0,
      panel: false,
      mobileHeight: { height: "100%" },
      startConversation: false,
      settingBeforeChat: {
        title: "Olá, eu sou o NEORON!",
        description:
          "Sou a Inteligência Artificial que\n foi desenvolvida pela FABWORK para \nfacilitar a criação de chatbots",
        starting_text: "Iniciar conversa!",
        page_background: {
          background:
            "linear-gradient(0deg, #FFFFFF, #F3FADD, #ACC1DB, #44709D, #114585)",
        },
        logo: "",
        button_settings: {
          background: "#e4e47b",
          color: "#114585",
        },
        text_settings: {
          color: "#114585",
        },
      },
    };
  },

  async created() {
    try {
      let response = null;
      let getData = null;

      if (!this.simulator_mode) {
        try {
          getData = await fetch("https://www.cloudflare.com/cdn-cgi/trace", {
            method: "get",
          });
          getData = (await getData.text())
            .replace(/[\r\n]+/g, '","')
            .replace(/\=+/g, '":"');
          getData = '{"' + getData.slice(0, getData.lastIndexOf('","')) + '"}';
          getData = JSON.parse(getData);
        } catch (e) {
          getData = null;
          e;
        }
      }

      if (this.custom_link) {
        response = await this.$store.dispatch("getBotStartup", {
          bot_alias_or_id: { bot_alias: this.custom_link },
          channel: "landing",
          anl: getData,
        });
        this.loaded = response ? true : false;
      } else if (this.bot_id_params) {
        response = await this.$store.dispatch("getBotStartup", {
          bot_alias_or_id: { bot_id: this.bot_id_params },
          channel: "landing",
          simulator_mode: this.simulator_mode,
          anl: getData,
        });
        this.loaded = response ? true : false;
      }
    } catch (error) {
      this.$router.push("/page-not-found");
    }
  },

  async mounted() {
    try {
      let { config_landing } = this.$store.state;
      window.addEventListener("resize", () => this.mobileScreen());
      this.mobileScreen();
      this.loading = "loaded";
      setTimeout(() => {
        this.loaded = true;
      }, 5000);
    } catch (err) {
      err;
    }
  },

  watch: {
    botLayout(val) {
      if (val && Object.entries(val).length === 0) {
        return;
      }
      this.title = val.title;
      this.subtitle = val.subtitle;
      this.logo =
        val.logo_image?.length > 0
          ? val.logo_image
          : (this.logoActived = false);
      this.botStyleConfig = {
        backgroundImage: `url(${val.background_image})`,
        backgroundColor: val.background_color,
        background: val.background,
        color: val.font_color,
        chatbot: {
          background_outgoing: val.background_outgoing || "#f1f1f1",
          background_received: val.background_received || "#4d4b4b",
          font_color_received: val.font_color_received || "#fff",
          font_color_outgoing: val.font_color_outgoing || "#000",
          logo_avatar: val.logo_avatar || false,
          enabled_logo_avatar: val.enabled_logo_avatar || false,
        },
        modelLayout: val.model_layout ?? "simple",
        pageMode: val.page_mode ?? "banner_and_chat",
        display: this.mode_layout_props === "widget" ? "none" : "flex",
      };

      this.botCustomSettings = {
        text_information_button: val.text_information_button || "Informações",
        text_chatbot_name:
          val.text_chatbot_name || this.$store.state.bot.name || "",
        enabled_chatbot_name: val.enabled_chatbot_name || false,
        text_page_title:
          val.text_page_title || this.$store.state.bot.name || " ",
      };
      this.links = val.links?.length > 0 ? val.links : [];

      if (val.settingBeforeChat) {
        const conversation_id = localStorage.getItem('conversation_id');
        this.settingBeforeChat = !!conversation_id ? false: val.settingBeforeChat;
        this.startConversation = !!conversation_id ? false: val.settingBeforeChat.activateBeforeChat;
      }
    },
  },

  computed: {
    bot_id() {
      return this.$store.state.bot.bot_id;
    },

    titleHeader() {
      if (this.mode_layout_props !== "widget") {
        return (document.title =
          (this.botCustomSettings.text_page_title
            ? this.botCustomSettings.text_page_title + " - "
            : "") + "NEORON");
      }
    },

    botLayout() {
      return this.$store.state.config_landing;
    },

    colorChatName() {
      let colorFont =
        this.botStyleConfig.modelLayout === "simple"
          ? "#000000a6"
          : this.botStyleConfig.color;
      return { color: colorFont };
    },

    nameBot() {
      return this.bot.name ?? "";
    },

    whiteLabel(){
      return this.bot.white_label ?? false;
    },

    imgBot() {
      return this.bot.photo ?? require("@/assets/img/profile.png");
    },

    ...mapState({
      bot: (state) => state.bot,
    }),
  },

  methods: {
    timeRefresh() {
      localStorage.removeItem('conversation_id');
      if (this.active === "active") return;
      this.showChat = false;
      this.active = "active";
      setTimeout(() => {
        this.showChat = true;
        this.active = "desactive";
      }, 1500);
    },

    mobileScreen() {
      this.widthScreen = window.innerWidth;
      if (this.widthScreen < 801) {
        this.mobileHeight = { height: `100%` };
      } else {
        this.mobileHeight = { height: `100%` };
      }
    },

    panelStatus(trueOrFalse) {
      this.panel = trueOrFalse;
    },

    handleStartConversation() {
      this.startConversation = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-page-container {
  height: 100%;

  & > div {
    height: 100%;
    width: 100%;
  }

  .loading-page {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    background: #fff;
    height: 100vh;

    .spin-neoron-chat {
      border: 6px solid #f3f3f3;
      border-top: 6px solid #8a9eac;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      margin: auto;
      animation: loader 1s linear infinite;
    }

    @media (max-width: 800px) {
      flex-direction: column;
    }

    @keyframes loader {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }
}

.neoron-landing-chat.landing-chat {
  &.centered {
    .message-form {
      .input-group {
        border-radius: 10px;
        margin: 0 20px;
      }
    }

    .form-control.message-input {
      border-radius: 8px;
      padding-right: 15%;
      padding-left: 15px;
    }
  }
}

#app-neoron {
  .box-chat {
    .widget {
      margin: 0;
    }

    .chat-page.chat-landing-page-neoron {
      min-height: 0;
      margin: 0 7px;

      .msg-inbox {
        height: 99% !important;

        @media (min-height: 975px) {
          height: 99% !important;
        }

        @media (max-height: 650px) {
          height: 97% !important;
        }

        .chats {
          height: 100%;

          .msg-page {
            height: 100%;

            & > div {
              height: 100%;

              .card-list {
                margin-bottom: 10px;
              }
            }
          }
        }

        @media (max-height: 700px) {
          height: 97% !important;
        }

        @media (max-weight: 440px) {
          height: 95% !important;
        }
      }

      .input-group {
        .form-control.message-input {
          width: 100%;
        }
      }

      p {
        img {
          max-width: 100%;
        }
      }
    }
  }
}

.modal-marketing {
  animation: fadeDown 0.5s;

  .ant-modal {
    width: 100% !important;
    max-width: 100%;
    top: 0;
    height: 100%;
    margin: 0;
    padding: 0;

    .ant-modal-content {
      height: 100%;

      .ant-modal-body {
        padding: 0;
        height: 100%;
      }
    }
  }

  @keyframes fadeDown {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }

    50% {
      opacity: 0.3;
      transform: translateY(-80px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>

<style lang="scss" scoped>
.neoron-landing-chat.landing-chat {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: flex;
  transition: all 0.2s ease;

  @media screen and (max-width: 800px) {
    overflow: hidden;
  }

  .custom-transition-template-enter-active {
    animation: fadeDown 0.5s;
  }

  &.centered {
    display: flex;

    .template .container {
      margin-right: 60%;

      @media screen and (max-width: 1125px) {
        margin-right: 58%;
      }

      @media screen and (max-width: 889px) {
        margin-right: 55%;
      }
    }

    .col.chat {
      position: absolute;
      background: transparent;
      max-width: 500px;
      right: 0;
      left: 0;
      bottom: 0;
      top: 0;
      max-height: 700px;
      margin: auto;
      margin-right: 10%;

      @media screen and (max-width: 1125px) {
        margin-right: 0%;
        margin-left: 55%;
        max-width: 390px;
      }

      @media screen and (max-width: 889px) {
        margin-right: 0%;
        margin-left: 55%;
        max-width: 355px;
      }
    }
  }

  .template {
    width: 100%;
    padding: 20px;
    font-size: 32px;
    font-weight: bold;
    font-family: "Open Sans", sans-serif;
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: center;
    display: flex;
    align-items: center;
    min-height: fit-content;

    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      right: 0;
      background: #0000006b;
    }

    .btn-close {
      position: absolute;
      top: 25px;
      right: 35px;
      display: none;

      p {
        font-size: 24px;
        margin: 0;
      }

      @media screen and (max-width: 800px) {
        display: block;
      }
    }

    .container {
      margin: 20px auto;
      position: relative;
      text-align: center;
      max-width: 500px;

      @media (max-width: 1200px) {
        max-width: 350px;
      }

      @media (max-width: 700px) {
        max-width: 80%;
      }

      .box-logo {
        margin-bottom: 10px;

        .image-logo {
          max-width: 250px;
          width: auto;
          height: auto;

          @media (max-width: 1500px) {
            max-width: 150px;
          }
        }
      }

      .box-title {
        justify-content: center;

        .title {
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .box-subtitle {
        justify-content: center;

        .subtitle {
          text-align: center;
          font-size: 24px;
          overflow: hidden;
          text-overflow: ellipsis;

          @media (max-width: 500px) {
            font-size: 16px;
          }
        }
      }

      .links {
        display: flex;
        justify-content: center;

        .col {
          width: 45px;
          max-width: 45px;

          a {
            font-size: 18px;
          }
        }
      }
    }

    @media (max-width: 800px) {
      padding: 10px;
      font-size: 18px;
      min-height: 100%;

      .container {
        top: 0;

        .row {
          width: fit-content;
          margin: auto;

          img {
            width: 100%;
          }
        }
      }
    }
  }

  .chat {
    position: relative;
    padding: 0px 0 20px;
    width: 100%;
    background: white;

    @media screen and (max-width: 800px) {
      min-height: 100%;
    }

    .padding-top-workaround {
      z-index: 1;
      background-color: #fff;
      padding-top: 50px;
      min-height: 20px;
      &.landing-channel {
        display: none;
      }
    }

    .header-chat {
      padding: 15px 15px 20px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .infoBot {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 5px;

        .bot-avatar {
          max-height: 35px;

          @media screen and (min-width: 1570px) {
            max-height: 30px;
          }

          @media screen and (max-width: 870px) {
            max-height: 25px;
          }

          @media screen and (max-width: 470px) {
            max-height: 20px;
          }
        }

        .nameBot {
          margin-left: 15px;
        }
      }

      .options {
        display: flex;

        .img-refresh {
          font-size: 35px;
          position: relative;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;

          &.active {
            animation: spin 1.2s linear;
          }
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .close-button {
          &::before,
          &::after {
            background: #2c2c2c;
          }
        }
      }
    }

    .box-chat {
      margin: auto;
      overflow: hidden;
      height: 100%;

      @media (min-width: 1200px) {
        height: 100%;
      }

      &.widget {
        @media (min-width: 1200px) {
          width: 100%;
          height: 100%;
          max-width: 700px;
        }

        padding: 0;

        .padding-top-workaround {
          display: none;

          @media screen and (max-width: 768px) {
            display: block;
          }
        }

        .header-chat {
          display: none;
        }
      }

      .chat-page {
        box-shadow: 0 0 1px #99949400;

        p {
          img {
            max-width: 100%;
          }
        }
      }
    }

    .loading {
      background: rgb(255, 255, 255);
      position: absolute;
      justify-content: center;
      width: 100%;
      display: flex;
      top: 0;
      height: 100vh;
      align-items: center;
      z-index: 10;
    }

    .loaded {
      display: none;
    }
  }

  .fade-splash-enter-active {
    animation: fadeDown 0.5s;
  }

  @keyframes fadeDown {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }

    50% {
      opacity: 0.3;
      transform: translateY(-80px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
